import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import { SEO_QUERY } from "Configs/queries";
import queryString from "query-string";
import { graphql } from "@apollo/client/react/hoc";
import withDefaultParams from "Services/withDefaultParams";

const withSEO = (route) => {
	return (ComposedComponent) =>
		withRouter(
			withDefaultParams(
				graphql(SEO_QUERY, {
					options: (props) => {
						let query = queryString.parse(props.location.search);
						return {
							variables: {
								...route.seo({
									...props.match.params,
									...query,
								}),
							},
						};
					},
					props: ({ data }) => {
						if (data.seoV3) {
							return { seoData: data.seoV3 };
						}
						return null;
					},
				})(
					class extends React.Component {
						render() {
							const { seoData } = this.props;
							return (
								<Fragment>
									<Helmet>
										<meta
											name="description"
											content={seoData && seoData.description ? seoData.description : ""}
										/>
										<meta
											name="keywords"
											content={seoData && seoData.keywords ? seoData.keywords : ""}
										/>
										<title>{seoData && seoData.title ? seoData.title : ""}</title>
									</Helmet>
									<ComposedComponent {...this.props} seoData={seoData} />
								</Fragment>
							);
						}
					}
				)
			)
		);
};

export default withSEO;
